import React from "react";
import HeaderComponent from "../../components/header/header.component";
import { ProductsProvider } from "../../store";

import { ContentLayout } from "../../layouts/content/content.layout";
import ProductContentComponent from "../../modules/products/components/product-content/product-content.component";

const ProductDetailsPage = (props: any) => {
  const productId = props.match.params.id;

  return (
    <ProductsProvider>
      <HeaderComponent />
      <ContentLayout>
        <ProductContentComponent productId={productId} />
      </ContentLayout>
    </ProductsProvider>
  );
};
export default ProductDetailsPage;
